import { Component } from '@angular/core';
import { combineLatest, of } from 'rxjs';
import { catchError, map, shareReplay, switchMap, take } from 'rxjs/operators';
import { FitnessReferenceDataService } from '../../services/fitness-reference-data.service';
import { FitnessMediaService } from '../../services/fitness-media.service';

/** Season branding around CAP's existing login, including its reset/2FA flows. */
@Component({
    selector: 'app-fitness-login',
    template: `<dw-login [style.--dw-logo-login-url]="(season$ | async)?.logoCss"
        [class.has-season-artwork]="!!(season$ | async)?.logoCss">
        <div top class="login-season-name">{{ (season$ | async)?.name }}</div>
    </dw-login>`,
})
export class FitnessLoginComponent {
    readonly season$ = this.reference.getActiveChallenge().pipe(take(1), switchMap(challenge =>
        combineLatest([
            this.reference.getProductPreview(challenge.ProductId),
            this.reference.getChallengeMedia(challenge.ChallengeDefinitionId),
        ]).pipe(take(1), switchMap(([product, assets]) => {
            const mediaId = product?.mediaId || assets.DEFAULT_USER_BANNER;
            return this.media.urls(mediaId ? [mediaId] : [], 300).pipe(map(urls => {
                const url = urls[mediaId] || product?.url;
                return { name: challenge.Name, logoCss: url ? `url(${JSON.stringify(url)})` : null };
            }));
        }))), catchError(() => of({ name: '', logoCss: null })),
        shareReplay({ bufferSize: 1, refCount: true }));

    constructor(private reference: FitnessReferenceDataService, private media: FitnessMediaService) {}
}
